/**
 * Core
 */
import React from 'react'
import { useEffect } from 'react'

/**
 * Components
 */
import Footer from '../components/footer'
import Mailto from '../components/mailto'
import icon from '../assets/images/icons/scxa-ticket.jpg'

/**
 * Hooks
 */
import useScrollTrigger from '../hooks/scroll-trigger.hook'




const RaiseTicket = () => {

    useScrollTrigger('.reveal');

    useEffect(() => {
        if (window.location.pathname === '/saudicxa-support-portal') {
          const script = document.createElement('script');
          script.src = 'https://cdn.awintern.com/scxa-raise-ticket1.js';
          script.async = true;
          document.body.appendChild(script);
          return () => {
            document.body.removeChild(script);
          };
        }
     } , []);
    
    return (
    
        
        <>
            <section className='bg-white text-ai-gray-900 py-16'>
                <div>
                    <h1 className='self-center bg-gradient-analagous-rose-triad-orange'>SaudiCXA Support Portal</h1>
                </div>
            </section>

            <section className='bg-gray-100 text-ai-gray-900 py-16 reveal top'>
                <div>
                   <h3>Welcome to the SaudiCXA Support Portal</h3>
                   <p>To ensure smooth communication and efficient task management between the CXKSA team and Awards International, we’ve introduced ZOHO Desk as our official support ticketing system.</p>
                   <p>This helps us track your requests, respond faster, and keep everything organised.</p>

                   <h3 className='mt-10'>Where to Find the Support Widget</h3>
                   <ul className='list'>
                     <li className='flex items-center'>You’ll see a <img src={icon} alt='icon' width={50}/> widget at the bottom-right corner of this page.</li>
                     <li>Click it to open the ticket form at any time.</li>
                   </ul>

                   <h3 className='mt-10'>How to Submit a Ticket</h3>
                   <ul className='list'>
                     <li className='flex items-center'><b>Click the Widget</b> &nbsp; located at the bottom-right corner of your screen <img src={icon} alt='icon' width={50}/></li>
                     <li><b>Click on the Submit a ticket button</b></li>
                     <li><b>Enter the Required Information</b></li>
                     <li><b>Name and email</b></li>
                     <li><b>Subject:</b> Brief summary of your request</li>
                     <li><b>Description:</b> Describe your request in detail. Add any relevant deadlines, links, or file attachments.</li>
                     <li>
                        <b>Product:</b> Click on the search icon to choose the relevant type (Technical, Marketing, Website, Awards Manager, or Event)
                        <ul className='list'>
                            <li><b>Technical</b> – For bugs, login problems, integrations, or other tech-related issues</li>
                            <li><b>Marketing</b> – For support with social media, email campaigns, banners, or promo materials</li>
                            <li><b>Website</b> – For content updates, page edits, or issues related to the event website</li>
                            <li><b>Awards Manager</b> – For any help with the Awards Manager platform (e.g. setup, judging, entries, bookings, export...)</li>
                            <li><b>Event</b> – For logistics, venue, agenda changes, attendee lists, or other event operations</li>
                        </ul>
                    </li>
                     <li><b>Additional information:</b> Priority and Classification</li>
                     <li><b>Submit</b></li>
                   </ul>
                   <p>Once submitted, you’ll receive an automatic confirmation email. Our team will begin reviewing your request shortly.</p>

                   <h3 className='mt-10'>Track and Respond</h3>
                   <p>You’ll be updated via email. Simply reply to the support email if you need to follow up.</p>

                   <h3 className='mt-10'>What to Use This For</h3>
                   <p>You can raise a ticket for anything related to:</p>

                   <ul className='list'>
                     <li>Website issues or content updates</li>
                     <li>Awards Manager platform queries</li>
                     <li>Marketing campaign support</li>
                     <li>Technical bugs or login problems</li>
                     <li>Questions about event tools or processes</li>
                   </ul>

                   <h3 className='mt-10'>Best Practices</h3>
                   <ul className='list'>
                     <li>One ticket = one task or issue</li>
                     <li>Include deadlines if the request is time-sensitive</li>
                     <li>Be as clear and specific as possible in your descriptions</li>
                   </ul>

                   <p>If you have any difficulties using the widget, please contact  <Mailto email="boris@awardsinternational.com" subject="SCXA26" body="Hello world!" className='mailto'>boris@awardsinternational.com</Mailto></p>
                </div>
            </section>
            
            <section className='pb-0 border-t border-t-ai-gray-800'>
                <Footer />
            </section>
        </>
    )
}


export default RaiseTicket




